import React, { Component } from "react";
import { Button, Modal, Spin } from "antd";
import { connect } from "dva";

import DetailModal from "../../../components/NormDetail";

const { confirm } = Modal;

@connect(({ tree }) => ({
  indexItem: tree.normDetail,
  templateType: tree.templateType,
  spinProps: tree.spinProps
}))
class NormDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "detail",
      changedFormValue: {
        changedNumberName: "", // 改变后的指标编号
        changedIndexName: "", // 改变后的指标名称
        changedMeasurement: "", // 改变后的评估标准
        changedRemark: "", // 改变后的备注说明
        changedCheckPoint: "", // 改变后的量化考核点
        changedIndexScore: "", // 改变后的指标分值
        changedAppendix: "" // 改变后的考评模版
      },
      form: {} // 详情的form
    };
  }

  componentDidMount() {
    this.handleFetchDetail();
  }

  handleChangeShow = () => {
    this.setState({
      type: "form"
    });
  };

  handleEdit = () => {
    const { changedFormValue, form } = this.state;
    const {
      changedNumberName,
      changedIndexName,
      changedMeasurement,
      changedRemark,
      changedCheckPoint,
      changedIndexScore,
      changedAppendix
    } = changedFormValue;
    const { dispatch, record, indexItem } = this.props;
    const { code, templateId, respondentOrgId } = record;
    const { validateFields } = form;
    const {
      name,
      number,
      measurement,
      remark,
      checkPoint,
      score,
      appendix
    } = indexItem;
    if (typeof validateFields === "function") {
      validateFields(err => {
        if (!err) {
          dispatch({
            type: "tree/changeNormDetail",
            payload: {
              indexCode: code,
              numberName: changedNumberName,
              nodeName: changedIndexName,
              remark: changedRemark,
              measurement: changedMeasurement,
              checkPoint: changedCheckPoint,
              score: changedIndexScore,
              appendix: changedAppendix,
              templateId,
              respondentOrgId: respondentOrgId || ""
            },
            callback: () => {
              this.handleFetchNormTree();
              this.handleFetchDetail();
            }
          });
          this.setState({
            type: "detail"
          });
        }
      });
    } else {
      dispatch({
        type: "tree/changeNormDetail",
        payload: {
          indexCode: code,
          numberName: number,
          nodeName: name,
          remark,
          measurement,
          checkPoint,
          score,
          appendix,
          templateId,
          respondentOrgId: respondentOrgId || ""
        },
        callback: () => {
          this.handleFetchNormTree();
          this.handleFetchDetail();
        }
      });
      this.setState({
        type: "detail"
      });
    }
  };

  handleDeleteNorm = () => {
    const { record, dispatch, renderRoot } = this.props;
    const { templateId, code, respondentOrgId } = record;
    dispatch({
      type: "tree/deleteNorm",
      payload: {
        indexCodes: [code],
        templateId,
        respondentOrgId: respondentOrgId || ""
      },
      callback: [this.handleFetchNormTree, renderRoot]
    });
  };

  // 对指标分组内容进行修改时的回调
  onEdit = ({
    number,
    name,
    measurement,
    remark,
    checkPoint,
    score,
    appendix,
    form
  }) => {
    this.setState({
      changedFormValue: {
        changedNumberName: number,
        changedIndexName: name,
        changedMeasurement: measurement,
        changedRemark: remark,
        changedCheckPoint: checkPoint,
        changedIndexScore: score,
        changedAppendix: appendix
      },
      form
    });
  };

  // 获取指标树
  handleFetchNormTree = () => {
    const { dispatch, record } = this.props;
    const { templateId, respondentOrgId } = record;
    dispatch({
      type: "tree/getNormTree",
      payload: {
        templateId,
        respondentOrgId: respondentOrgId || ""
      }
    });
  };

  handleFetchDetail = () => {
    const { record, dispatch } = this.props;
    const { templateId, code, respondentOrgId } = record;
    dispatch({
      type: "tree/getNormDetail",
      payload: {
        templateId,
        respondentOrgId: respondentOrgId || "",
        indexCode: code
      }
    });
  };

  renderDeleteModal = () => {
    // const { selectedRowKeys, dispatch } = this.props;
    const deleteProps = {
      title: `删除指标`,
      content: "确定删除选中的指标吗？",
      okText: "确定",
      cancelText: "取消",
      centered: true,
      onOk: this.handleDeleteNorm
    };
    confirm({ ...deleteProps });
    return false;
  };

  render() {
    const { type } = this.state;
    const { indexItem, templateType, spinProps } = this.props;
    return (
      <div>
        <Spin {...spinProps}>
          {type === "detail" && (
            <Button
              onClick={this.handleChangeShow}
              style={{ marginBottom: 15 }}
              type="primary"
            >
              编辑
            </Button>
          )}
          <DetailModal
            type={type}
            rest={indexItem}
            templateType={templateType}
            onEdit={this.onEdit}
          />
          {type === "form" && (
            <Button
              onClick={this.handleEdit}
              style={{ marginBottom: 15 }}
              type="primary"
            >
              保存修改
            </Button>
          )}
          {type === "form" && (
            <Button
              onClick={this.renderDeleteModal}
              style={{ marginBottom: 15, marginLeft: 15 }}
            >
              删除指标
            </Button>
          )}
        </Spin>
      </div>
    );
  }
}

export default NormDetail;
